// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminReorderReminders = (client) => ({
    /**
     * `GET /admin/reorder-reminders/orders/:order_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminReorderRemindersOrderRetrieve
     * @source apps/backend/src/api/admin/reorder-reminders/orders/[order_id]/route.ts
     */
    retrieveOrder: (orderId, query, headers) => client.fetch(buildPath("/admin/reorder-reminders/orders/:order_id", [orderId]), { method: "GET", query, headers }),
    /**
     * `POST /admin/reorder-reminders/orders/:order_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminReorderRemindersOrderUpdate
     * @source apps/backend/src/api/admin/reorder-reminders/orders/[order_id]/route.ts
     */
    updateOrder: (orderId, body, query, headers) => client.fetch(buildPath("/admin/reorder-reminders/orders/:order_id", [orderId]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=reorder-reminders.js.map